<template>
    <v-autocomplete filled outlined dense label="Clientes" hide-details="auto" :items="db.clientes"
        :item-text="displayText" item-value="uuid" v-model="plantilla.refUuid" return-object @change="submit">
        <template v-slot:append-outer class="ma-0">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="info darken-1" size="30" @click="generate"
                        style="cursor: pointer">mdi-file-download-outline</v-icon>
                </template>
                <span>Genera formato de ejemplo con la entidad seleccionada y descarga el
                    fichero</span>
            </v-tooltip>
        </template>
    </v-autocomplete>
</template>

<script>
import moment from 'moment'


export default {
    props: {
        plantilla: {
            type: Object,
            default: () => ({})
        },


    },
    data: () => ({
        db: {
            clientes: []
        }
    }),
    methods: {
        displayText(item) {
            return `${item.nombreCompleto}`
        },
        submit() {
            this.$emit('input', this.plantilla)
        },
        generate() {
            this.$emit('generate')
        },

        async getClientes() {
            if (!this.plantilla.subalcance) return

            let subalcance_uuid = typeof this.plantilla.subalcance === 'object'
                ? this.plantilla.subalcance.uuid
                : this.plantilla.subalcance

            const clientes = await this.$store.dispatch('clientes/list')
            this.db.clientes = clientes.data['hydra:member']
        },

        async init() {
            await this.getClientes()
        }
    },

    mounted() {
        this.init()
    }
}
</script>